$(document).ready(function() {
  var modal = document.getElementById("surveyModal");

  $(".survey-modal-nojs")
    .removeClass("survey-modal-nojs card")
    .addClass("survey-modal");
  $(".survey-modal__content-nojs")
    .removeClass("survey-modal__content-nojs")
    .addClass("survey-modal__content");

  $(".survey-modal__close,.survey-modal__close--nocss").on("click", function(e) {
    e.preventDefault();
    $("#surveyModal").css("display", "none");
  });

  $(".text-for-radio").on("click", function() {
    $(this)
      .parent()
      .find("input[type=radio], input[type=checkbox]")
      .prop("checked", true)
      .trigger("change");
  });

  $(".sub-checkbox").on("change", function() {
    if($(this).prop('checked') == true){
      var parentElement = $(this).attr('for');
      $('#' + parentElement).prop("checked", true);
    }
  });

  var optionsName = $(".option_with_options").attr("name");

  $("input[name=" + optionsName + "]").on("click", function() {
    if( $("[name=radio_1].option_with_options").prop('checked') == false) {
      $("input[for^='option_with_options']").prop("checked", false);
    }
  });

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
});
